export const PAYMENT_INSTRUCTIONS_CASH = [
	<li key={1}>
		<strong>1.</strong> Acude a la tienda OXXO más cercana.{' '}
		<a
			href='https://www.google.com.mx/maps/search/oxxo/'
			target='_blank'
			className='!text-h-primary'
		>
			Encuéntrala aquí
		</a>
		.
	</li>,
	<li key={2}>
		<strong>2.</strong> Indica en caja que quieres realizar un pago de{' '}
		<strong>OXXOPay</strong>.
	</li>,
	<li key={3}>
		<strong>3.</strong> Muestra el código de barras de tu ficha o dicta el
		número de referencia al cajero.
	</li>,
	<li key={4}>
		<strong>4.</strong> Realiza el pago correspondiente con dinero en efectivo.
	</li>,
	<li key={5}>
		<strong>5.</strong> Al confirmar tu pago, el cajero te entregará un
		comprobante impreso.{' '}
		<strong>En él podrás verificar que se haya realizado correctamente.</strong>{' '}
		Conserva este comprobante de pago.
	</li>,
];

export const PAYMENT_INSTRUCTIONS_SPEI = [
	<li>
		<strong>1.</strong> Accede a tu banca en línea.
	</li>,
	<li>
		<strong>2. </strong>
		<b>Da de alta la CLABE en esta ficha. </b>
	</li>,
	<li>
		<strong>3. </strong>
		<span>
			El banco destino es <strong>Citi</strong>. La cuenta es válida y pertenece a nuestra
			plataforma de pagos
		</span>
	</li>,
	<li>
		<strong>4.</strong> Como beneficiario y concepto ingresa el nombre{' '}
		<strong>"Heru Servicios"</strong>.
	</li>,
	<li>
		<strong>5.</strong> Realiza la transferencia correspondiente por la cantidad
		exacta en esta ficha, <strong>de lo contrario se rechazará el cargo</strong>
		.
	</li>,
	<li>
		<strong>6.</strong>Al confirmar tu pago, el portal de tu banco generará un
		comprobante digital.{' '}
		<strong>En el podrás verificar que se haya realizado correctamente.</strong>{' '}
		Conserva este comprobante de pago.
	</li>,
];
